module.exports = __webpack_public_path__ + "img/img-service-04@2x.c279bb78.jpg";